import React, { useRef } from 'react';
import { Carousel } from '@mantine/carousel';
import { Container, Title, Text, Button, Overlay } from '@mantine/core';
import { Link } from 'react-router-dom';
import Autoplay from 'embla-carousel-autoplay';
import { Helmet } from 'react-helmet-async';

import defaultContent from '../../data/defaultContent.json';

export const HeroCarousel: React.FC = () => {
  const autoplay = useRef(Autoplay({ delay: 5000 }));

  const slides = defaultContent.pages.home.heroSlides;

  return (
    <>
      {/* ✅ Preload FIRST image */}
      <Helmet>
        <link rel="preload" as="image" href={slides[0]?.image} />
      </Helmet>

      <Carousel
        withIndicators
        height={600}
        loop
        plugins={[autoplay.current]}
        onMouseEnter={autoplay.current.stop}
        onMouseLeave={autoplay.current.reset}
        styles={{
          indicator: {
            width: 12,
            height: 4,
            transition: 'width 250ms ease',
            backgroundColor: 'white',
            '&[data-active]': {
              width: 40,
            },
          },
        }}
      >
        {slides.map((slide: any, index: number) => (
          <Carousel.Slide key={slide.id}>
            <div
              style={{
                height: '100%',
                position: 'relative',
                backgroundColor: '#0f172a', // ✅ instant paint (no blank screen)
              }}
            >
              {/* ✅ Optimized Image */}
              <img
                src={slide.image}
                alt={slide.title}
                loading={index === 0 ? 'eager' : 'lazy'}
                fetchPriority={index === 0 ? 'high' : 'auto'}
                decoding="async"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
              />

              <Overlay
                gradient="linear-gradient(45deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 100%)"
                opacity={0.6}
                zIndex={1}
              />

              <Container
                size="xl"
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  zIndex: 2,
                }}
              >
                <div style={{ maxWidth: 600 }}>
                  <Title
                    size="3rem"
                    fw={800}
                    style={{ color: 'white', marginBottom: '1rem' }}
                  >
                    {slide.title}
                  </Title>

                  <Text
                    size="xl"
                    style={{ color: 'white', marginBottom: '2rem', opacity: 0.9 }}
                  >
                    {slide.subtitle}
                  </Text>

                  {slide.ctaText && slide.ctaLink && (
                    <Button
                      component={Link}
                      to={slide.ctaLink}
                      size="lg"
                      color="primary"
                    >
                      {slide.ctaText}
                    </Button>
                  )}
                </div>
              </Container>
            </div>
          </Carousel.Slide>
        ))}
      </Carousel>
    </>
  );
};